<template src="./ArrobaMedellinFooter.html" />

<script>
export default {
  name: 'arroba-medellin-footer',
}
</script>

<style lang="scss" scoped src="./ArrobaMedellinFooter.scss" />
